import Loading from "../../app/loading";

const CustomButton = ({ borderRadius = "default", theme, title, loading = false, ...rest }) => {
	const buttonTypeClass = () => {
	  switch (theme) {
		case "primary":
		  return "primary";
		case "secondary":
		  return "secondary";
		case "tertiary":
		  return "tertiary";
		default:
		  return "primary";
	  }
	};
  
	return (
	  <button
		className={`transition font-mulish ${buttonTypeClass()} ${
		  borderRadius !== "default" && "b-r-0"
		}`}
		disabled={loading || rest.disabled} 
		{...rest}
		
	  >
		<span>
		  {loading ? <Loading /> : <span>{title}</span>} 
		</span>
	  </button>
	);
  };
  
  export default CustomButton;
  